import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ConfigService } from '../../../core/services/config/config.service';
import { UtilityService } from '../../../core/services/utility/utility.service';
import { User } from '../../models/user';
import { UserRequest } from '../../models/user-request';

@Injectable({
  providedIn: 'root',
})
export class UserRequestService {
  private utilityService = inject(UtilityService);
  private configService = inject(ConfigService);
  private config = this.configService.config;

  portalUserRequestsEndpoint = this.config.patientApiUrl + '/v1/PatientPortal/UserRequests';

  insertUserRequest(request: UserRequest): Observable<User> {
    return this.utilityService.postRequest<User>(this.portalUserRequestsEndpoint, request);
  }
}
